import React, { useEffect } from 'react';

// redux
import { closeMenu } from 'store'
import { useDispatch } from 'react-redux';

// component
import Header from 'component/Header';
import Menu from 'component/Menu';
import Footer from 'component/Footer';

import './PageAbout.scss';

type Props = {
  testPath: string,
}

const PageAbout: React.FC<Props> = (props) => {

  // dispatch
  const dispatch = useDispatch();

  // Effect
  useEffect(() => {
    // タイトルなど
    // document.title = 'ショールームについて';

    // ページ遷移時にメニューを閉じる
    return () => {
      dispatch(closeMenu());
    }
  });

  return (
    <div id="PageAbout">
      <Header />
      <Menu />
      <div className="bg">
        <div className="topTitle">
          <h2 className="c-h2">ABOUT SHOWROOM</h2>
        </div>
        <div className="lead">ショールームについて</div>
        <div className="bgWhite">
          <dl>
            <dt>営業時間</dt>
            <dd>平日 10:00〜16:00（最終入館15:30）</dd>
          </dl>
          <dl>
            <dt>休館日</dt>
            <dd>土日祝日、年末年始、夏季休業日、5月1日、改装工事期間（不定期）</dd>
          </dl>
          <dl>
            <dt>住所</dt>
            <dd>〒108-8710 東京都港区港南1丁目8番35号</dd>
          </dl>
          <dl>
            <dt>電話番号</dt>
            <dd>
              <p>
                <strong>ショールームに関するお問合わせ</strong><br />
                06-6976-1221（代表）
              </p>
              <p>
                <strong>商品に関するお問合わせ</strong><br />
                コクヨお客様相談室<br />
                フリーダイヤル 0120-201-594
              </p>
              <p className="note">
                ※電話およびFAXからのお問合わせ窓口業務を一部縮小しています。<br />
                詳しくは下記ページをご参照ください。<br />
                <a href="https://www.kokuyo.co.jp/support/contact/" target="blank">https://www.kokuyo.co.jp/support/contact/</a>
              </p>
            </dd>
          </dl>
          <dl>
            <dt>展示面積</dt>
            <dd>3,000平米</dd>
          </dl>
          <dl>
            <dt>展示内容</dt>
            <dd>オフィス空間（事務用回転イス、デスクシステム、収納システム、会議室・ミーティングスペース）<br />
              官公庁・公共施設用家具<br />
              医療施設用家具<br />
              教育施設用家具<br />
              エグゼクティブ用家具<br />
              建材
            </dd>
          </dl>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default PageAbout;
